import angular from 'angular';
import requestPasswordResetComponent from './requestPasswordReset.component';
import RequestPasswordResetService from './requestPasswordReset.service';

let requestPasswordResetModule = angular.module('requestPasswordReset', [])
  .component('requestPasswordReset', requestPasswordResetComponent)
  .service('requestPasswordResetService', RequestPasswordResetService);

export default requestPasswordResetModule;



// WEBPACK FOOTER //
// ./app/components/requestPasswordReset/requestPasswordReset.js